<template>
  <b-row class="justify-content-center my-5">
    <b-col cols="10" lg="6" class="sg-rounded-container">
      <b-row class="justify-content-center">
        <b-col cols="12" lg="8" class="p-5">
          <b-img
            :src="require('@/assets/img/customer/sad-broke.png')"
            fluid
          />
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="10">
          <h4>Whoops!</h4>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col cols="10">
          <h6>
            We couldn't process your payment, please try again later..
          </h6>
        </b-col>
      </b-row>

      <b-row class="mt-3" />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Pay_Failed'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Pay/Failed.vue